export enum LUXON_DATUM_FORMATS {
  UITGESCHREVEN = 'EEE. d MMM yyyy',
  VERKORT = 'dd-MM-yyyy',
}
